import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { history, ROLES } from "../../../../utils";

export function ModuleExam({
  moduleQuizAdvance,
  courseModule,
}) {
  const user = useSelector((state) => state.user);
  const courseAdvance = useSelector((state) => state.courseAdvance);

  const examAdvance = useMemo(() => {
    return courseAdvance?.examsAdvance?.find(
      (currentExamAdvance) =>
        currentExamAdvance?.section?.id === courseModule?.id &&
        currentExamAdvance?.section?.quiz?.id === courseModule?.quizId
    );
  }, [courseAdvance, courseModule]);

  const lastModuleClassAdvance = useMemo(() => {
    const classes = courseModule?.classes;

    return courseAdvance?.classesAdvance?.find(
      (currentClass) =>
        currentClass?.lessonId === classes?.[classes?.length - 1]?.id
    );
  }, [courseModule.classes, courseAdvance.classesAdvance]);

  const isLocked = () => {
    if (user?.roleId === ROLES.admin) return false;

    if (!lastModuleClassAdvance) return true;

    return false;
  };

  const completed = Boolean(moduleQuizAdvance || examAdvance);
  const locked = isLocked();

  const handleOpenExam = () => {
    if (locked || completed) return;

    history.push(`/examen/${courseModule.quizId}`, {
      slug: "course quiz",
      section_id: courseModule.id,
    });
  };

  return (
    <div className={`modern-exam-card ${locked ? "is-locked" : ""}`}>

      <div className="modern-exam-status">
        <div
          className={`modern-exam-status-icon ${
            completed ? "completed" : locked ? "locked" : "available"
          }`}
        >
          <i
            className={
              completed
                ? "fas fa-check"
                : locked
                ? "fas fa-lock"
                : "fas fa-clipboard-check"
            }
          />
        </div>

        <div className="modern-exam-copy">
          <span>EVALUACIÓN</span>
          <strong>Examen del módulo</strong>

          <p>
            {completed
              ? "Evaluación completada."
              : locked
              ? "Completa el contenido del módulo para desbloquearla."
              : "Ya puedes realizar la evaluación de este módulo."}
          </p>
        </div>
      </div>

      <div className="modern-exam-action">
        {completed ? (
          <span className="modern-exam-badge completed">
            <i className="fas fa-check-circle" />
            Completado
          </span>
        ) : locked ? (
          <span className="modern-exam-badge locked">
            <i className="fas fa-lock" />
            Bloqueado
          </span>
        ) : (
          <button
            type="button"
            onClick={handleOpenExam}
            className="modern-exam-button"
          >
            Iniciar examen
            <i className="fas fa-arrow-right" />
          </button>
        )}
      </div>

    </div>
  );
}
